export const XS = '0px 0px 0px 1px rgba(0, 0, 0, 0.05)';

export const SM = '0px 1px 2px 0px rgba(0, 0, 0, 0.05)';

export const BASE =
    '0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)';

export const MD =
    '0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.10)';

export const LG =
    '0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.10)';

export const XL =
    '0px 10px 10px -5px rgba(0, 0, 0, 0.04), 0px 20px 25px -5px rgba(0, 0, 0, 0.10)';

export const XXL = '0px 25px 50px -12px rgba(0, 0, 0, 0.25)';

export const XXXL = '0px 15px 40px 0px rgba(0, 0, 0, 0.40)';

export const OUTLINE = '0px 0px 0px 3px rgba(63, 153, 225, 0.60)';

export const INNER = 'inset 0px 2px 4px 0px rgba(0, 0, 0, 0.06)';

export const NONE = 'none';

const BasicShadow = {
    XS,
    SM,
    BASE,
    MD,
    LG,
    XL,
    XXL,
    XXXL,
    OUTLINE,
    INNER,
    NONE,
};

export default BasicShadow;
